"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialsContainer = SocialsContainer;
var React = _interopRequireWildcard(require("react"));
var _RootContainer = require("../RootContainer");
var _socials = require("../../components/socials");
var _social = require("../../actions/social");
var _useDeprecatedSocialCallback = require("./hooks/useDeprecatedSocialCallback");
var _selectors = require("./selectors");
var _constants = require("./constants");
var _source = require("../../selectors/source");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function SocialsContainer(_ref) {
  let {
    useDispatch,
    useSelector
  } = _ref;
  const {
    disabledSocials,
    frameless
  } = React.useContext(_RootContainer.RootContext);
  const dispatch = useDispatch();
  const expanded = useSelector(_selectors.expandedSelector);
  const source = useSelector(_source.sourceSelector);
  const error = useSelector(_selectors.socialErrorSelector);
  const handleSocialClick = (0, _useDeprecatedSocialCallback.useDeprecatedSocialCallback)(useDispatch, source);
  const {
    socialListFull,
    socialListShort
  } = React.useMemo(() => {
    const socialListFull = _constants.SOCIAL_NETWORKS.filter(social => !disabledSocials.includes(social));
    const socialListShort = socialListFull.slice(0, _constants.VISIBLE_SOCIALS_COUNT);
    return {
      socialListFull,
      socialListShort
    };
  }, [disabledSocials]);

  // Если сейчас доступно INITIALLY_EXPANDED_SOCIALS_LIMIT соц сетей,
  // то нет смысла скрывать их под кнопкой "раскрыть", показываем все сразу
  const isExpanded = socialListFull.length <= _constants.INITIALLY_EXPANDED_SOCIALS_LIMIT || expanded;
  const currentSocialList = isExpanded ? socialListFull : socialListShort;
  const handleExpand = React.useCallback(() => {
    if (!expanded) {
      dispatch((0, _social.expand)());
    }
  }, [dispatch, expanded]);
  if (socialListFull.length === 0) {
    return null;
  }
  return /*#__PURE__*/React.createElement(_socials.SocialsWrapper, {
    list: currentSocialList,
    isExpanded: isExpanded,
    expand: handleExpand,
    error: error,
    frameless: frameless,
    onClick: handleSocialClick
  });
}